/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
//# sourceMappingURL=not.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/not.js
// module id = 296
// module chunks = 0